export enum AwEventType {
  WebinarViewed = "webinar_viewed",
  MomentShared = "moment_shared",
  VideoPlayed = "video_played",
  WidgetViewed = "widget_viewed"
}
